const widgetSrc = (appId) => `https://widget.intercom.io/widget/${appId}`;

let widgetLoaded = false;

function loadWidget(appId) {
  if (widgetLoaded || typeof document === 'undefined') return;
  const s = document.createElement('script');
  s.type = 'text/javascript';
  s.async = true;
  s.src = widgetSrc(appId);
  const x = document.getElementsByTagName('script')[0];
  if (x && x.parentNode) {
    x.parentNode.insertBefore(s, x);
  } else {
    document.head.appendChild(s);
  }
  widgetLoaded = true;
}

export const intercomService = {
  boot(intercomData) {
    if (!intercomData?.app_id) return;
    if (typeof window === 'undefined' || !window.Intercom) return;

    loadWidget(intercomData.app_id);

    const company = intercomData.companies?.find(
      (c) => c.company_id === intercomData.current_company_id
    );

    window.Intercom('boot', {
      app_id: intercomData.app_id,
      user_id: intercomData.user.user_id,
      user_hash: intercomData.user_hash,
      ...intercomData.user,
      company,
      companies: intercomData.companies,
    });
  },

  updateCompany(intercomData, workspaceId) {
    if (typeof window === 'undefined' || !window.Intercom) return;
    if (!intercomData?.companies) return;

    const company = intercomData.companies.find(
      (c) => c.company_id === String(workspaceId)
    );
    if (!company) return;

    window.Intercom('update', { company });
  },

  shutdown() {
    if (typeof window === 'undefined' || !window.Intercom) return;
    window.Intercom('shutdown');
  },
};
